import { render, staticRenderFns } from "./VerCertificadoModal.vue?vue&type=template&id=6c0ccecf&"
import script from "./VerCertificadoModal.vue?vue&type=script&lang=ts&"
export * from "./VerCertificadoModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6c0ccecf', component.options)
    } else {
      api.reload('6c0ccecf', component.options)
    }
    module.hot.accept("./VerCertificadoModal.vue?vue&type=template&id=6c0ccecf&", function () {
      api.rerender('6c0ccecf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/CertificadosBase/VerCertificadoModal.vue"
export default component.exports